<template lang="pug">
  nav.ui-breadcrumbs.breadcrumb(aria-label="breadcrumbs"): ul
    template(v-for="{route, name, active} in items")
      router-link(v-if="route" tag="li" :to="route" exact): a {{ name }}
      li(v-else :class='{"is-active":active}'): a {{ name }}
</template>

<script>
export default {
  name: 'ui-breadcrumbs',

  props: {
    items: Array,
  },
};
</script>
